import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';
import { ProgressBar } from '@verclam/ui-kit';

const wrapperStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

const countStyle = css`
	margin: 0;
	font-family: ${theme.fonts.mono};
	font-size: ${theme.fontSizes.small};
	color: ${theme.colors.inkFaint};
`;

const BAR_STYLE = {
	'--ui-kit-progress-bar-bg': theme.colors.track,
	'--ui-kit-progress-bar-height': '0.625rem',
	'--ui-kit-progress-bar-radius': theme.radii.pill,
};

type Props = {
	/** `0` to `1`; `null` while the queue has not reported any yet. */
	readonly progress: number | null;
	readonly segmentCount: number;
};

/** The only honestly measurable part of the page: how many chunks of the recording have left the device. */
const TransferProgress: React.FC<Props> = ({ progress, segmentCount }) => {
	const sentCount = progress !== null ? Math.round(progress * segmentCount) : 0;
	const unit = sentCount > 1 ? 'morceaux' : 'morceau';

	return (
		<div css={wrapperStyle}>
			<ProgressBar
				value={progress !== null ? progress * 100 : null}
				mode={progress !== null ? 'determinate' : 'indeterminate'}
				showValue={false}
				color={theme.colors.accent}
				style={BAR_STYLE}
				aria-label="Avancement du transfert"
			/>
			<ConditionalLoader data={segmentCount > 1}>
				<p css={countStyle}>{`${sentCount} ${unit} sur ${segmentCount}`}</p>
			</ConditionalLoader>
		</div>
	);
};

export default TransferProgress;
